import { useDisclosure } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { Plus } from 'lucide-react';
import { TeamMemberInternalEnrolmentForm } from './TeamMemberInternalEnrolmentForm';
import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';

export function TeamMemberFormModal() {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <FormModalWrapper
      modalOpenButtonText={t`Invite team member`}
      modalOpenButtonLeftIcon={Plus}
      modalContent={<TeamMemberInternalEnrolmentForm onClose={onClose} />}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      modalContentHeight="auto"
      modalCloseButton={false}
    />
  );
}
